module.exports = __webpack_public_path__ + "static/media/citcuito.53e41fda.svg";